import {Component, inject, Inject, Input, OnInit} from '@angular/core';
import { HasPermissionDirective } from '@shared/directives/has-permission.directive';
import {ContactosServiciosService} from './contactos-servicios.service';
import {ErrorService} from '../../../../../shared/services/error.service';
import {ContactoServicio} from './contactos-servicios.interface';
import {DeleteTrigger} from '../../../../../shared/components/ui/delete-trigger/delete-trigger';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogService} from '@shared/services/dialog.service';
import {CrearContactoServicio} from './crear-contacto-servicio/crear-contacto-servicio';
import {DetalleContactoServicio} from './detalle-contacto-servicio/detalle-contacto-servicio';
import {SnackbarService} from '@shared/services/snackbar.service';
import {IconButton} from '../../../../../shared/components/ui/icon-button/icon-button';
import {DataTable, TableCellDirective, TableColumn} from '@shared/components/ui/list-components';
import {Modal} from '@shared/components/common/modal/modal';

@Component({
  selector: 'app-contactos-servicios',
  imports: [
    HasPermissionDirective,
    DeleteTrigger,
    IconButton,
    DataTable,
    TableCellDirective,
    Modal,
  ],
  templateUrl: './contactos-servicios.html',
  styles: ``
})
export class ContactosServicios implements OnInit{

  @Input() idContacto!: number;
  contactosServicios!: ContactoServicio[];
  loading = false;
  deleting = false;
  deletingIndex: number | null = null;

  columns: TableColumn[] = [
    { key: 'servicio_nombre', header: 'Servicio' },
    { key: 'acciones', header: 'Acciones' },
  ];

  private contactosServiciosService = inject(ContactosServiciosService);
  private errorService = inject(ErrorService);
  private snackbarService = inject(SnackbarService);
  private dialogService = inject(DialogService);
  private dialogRef = inject(MatDialogRef<ContactosServicios>, { optional: true });

  constructor(@Inject(MAT_DIALOG_DATA) public data?: number) {
    if (data) {
      this.idContacto = data;
    }
  }

  ngOnInit(): void {
    this.getContactosServicios();
  }

  getContactosServicios(): void {
    this.loading = true;
    this.contactosServiciosService.index(this.idContacto).subscribe({
      next: (response) => {
        if (response.status) {
          this.contactosServicios = response.data;
        }
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  openCreateModal(): void {
    this.dialogService.openForm(CrearContactoServicio, {
      size: 'md',
      data: this.idContacto
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getContactosServicios();
      }
    });
  }

  openViewModal(id: number): void {
    this.dialogService.openForm(DetalleContactoServicio, {
      size: 'md',
      data: {
        idContactoServicio: id,
        idContacto: this.idContacto
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getContactosServicios();
      }
    });
  }

  delete(id: number, index: number): void {
    this.deleting = true;
    this.deletingIndex = index;

    this.contactosServiciosService.destroy(id).subscribe({
      next: (response) => {
        if (response.status) {
          this.snackbarService.showSnackBar('Servicio del contacto eliminado correctamente');
          this.getContactosServicios();
        }
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.deleting = false;
      this.deletingIndex = null;
    });
  }

  closeModal(): void {
    this.dialogRef?.close();
  }
}
